import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeFirestoreTimestamp,
  nullSafeOptionalString,
} from '../shared/schema'

export const schema = z.object({
  sectionId: nullSafeOptionalString(),
  assignmentId: nullSafeOptionalString(),
  userId: nullSafeOptionalString(),
  conversationError: nullSafeOptionalString(),
  createdAt: nullSafeFirestoreTimestamp(),
  updatedAt: nullSafeFirestoreTimestamp(),
})

export const writeSchema = schema.extend({
  createdAt: firestoreWriteTimestamp,
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(schema.parse({}))

export interface FirestoreSectionAssignmentConversation extends z.infer<
  typeof schema
> {}
